module.exports = __webpack_public_path__ + "static/media/VP_1_GRAPHIC.311a320b.svg";